import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SensorUpload } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseQueryOptions<unknown, Error, SensorUpload>,
    'queryKey' | 'queryFn'
  >;
}

export const useSensorUploadRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, SensorUpload>(
    [Entities.SensorUploads, id],
    async () => {
      const { data } = await api.v1AdminSensorUploadsUploadIdGet(id)
      return data
    },
    { ...options },
  )
}
